import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('IconLink', null, {
    withChildren: true, // eslint-disable-next-line react/display-name
    innerDependence: ({ Element = 'button', disabled, children, type, innerRef, source, ...iconLinkProps }) => {
        return <Element {...iconLinkProps} />;
    },
});
